import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'textToClass' })
export class TextToClassPipe implements PipeTransform {
  transform(text: string): string {
    if (!text) {
      return '';
    }
    return text.toLowerCase().replace(/[^A-Za-z]+/g, '-');
  }
}
